import { Box, Grid } from '@mui/material';
import { useState } from 'react'
import { useAppContext } from '../../../libs/app-core/AppContext';
import { Toast } from '../../../libs/app-core/Toast';
import { linear_content_style, linear_h, linear_item } from '../../../libs/linear-layout/LinearLayout';
import { UniFormDAO, useUniFormList } from '../../dao/UniFormDAO';
import { UniFunc } from '../../dao/UniFunc';
import { useUniFuncList } from '../../dao/UniFuncDAO';
import { OnApiError } from '../../ErrorManager';
import { R } from '../../R';
import DgvUniFunc from './DgvUniFunc';
import DgvUniForm from './DgvUniForm';
import { ROUTE_form_def } from '../../Routes';

type Props = {}

const FrmUniFuncDefinition = (props: Props) => {

  const ctx = useAppContext();

  const { _UniFuncList } = useUniFuncList();

  const [CurrUniFunc, setCurrUniFunc] = useState<UniFunc | null>(null);

  const { _UniFormList, refresh_UniFormList } = useUniFormList(CurrUniFunc?.guid);

  return (
    <Box style={linear_content_style} bgcolor={R.color.paper} sx={{ p: 2 }}>
      <Grid {...linear_h} >
        <Grid {...linear_item} flex={3} sx={{ px: 1 }} >
          <DgvUniFunc
            DataList={_UniFuncList}
            OnRowSelected={(sel_func) => {
              setCurrUniFunc((sel_func));
            }}
          />
        </Grid>
        <Grid {...linear_item} flex={2} sx={{ px: 1 }}>
          <DgvUniForm CurrUniFunc={CurrUniFunc}
            DataList={_UniFormList}
            OnRowDoubleClick={(sel_form) => {
              ctx.Navigate(ROUTE_form_def.url + "?form=" + sel_form.guid);
            }}

            OnAddUniFormClick={btn_新增版本_Click}
          />
        </Grid>
      </Grid>
    </Box>
  )

  async function btn_新增版本_Click() {
    try {
      if (CurrUniFunc == null || CurrUniFunc.guid == null) {
        Toast.ShowWarning(ctx, "請先選擇問卷");
        return;
      }

      await UniFormDAO.Insert_空白問卷版本(CurrUniFunc);

      await refresh_UniFormList();

      Toast.Show(ctx, "新增版本");

    } catch (ex: any) {
      OnApiError(ctx, ex);
    }
  }

}






export default FrmUniFuncDefinition